import RequiredForTask from './RequiredForTask';

export default RequiredForTask;
